function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="12" height="13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 0C2.686 0 0 2.498 0 5.58 0 7.334.872 8.9 2.236 9.923v2.128l2.043-1.127A6.422 6.422 0 0 0 6 11.16c3.314 0 6-2.498 6-5.58S9.314 0 6 0zm.596 7.514L5.068 5.877 2.087 7.514l3.28-3.497 1.565 1.637 2.944-1.637-3.28 3.497z" fill="#4B2118" /></svg>;
});